import(/* webpackMode: "eager", webpackExports: ["Text","Button"] */ "/vercel/path0/node_modules/.pnpm/@zapier+design-system@8.8.3_@types+react@18.3.11_react-dom@18.3.1_react@18.3.1/node_modules/@zapier/design-system/dist/index.es.js");
